import { render, staticRenderFns } from "./insurerInfo.vue?vue&type=template&id=347eb20f&scoped=true&"
import script from "./insurerInfo.vue?vue&type=script&lang=js&"
export * from "./insurerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347eb20f",
  null
  
)

export default component.exports